import React, { useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  Table,
  FormCheck,
  Form,
  Row,
  Col,
  Pagination,
  OverlayTrigger,
  Spinner,
} from "react-bootstrap";
import axios from "axios";
import { API_BASE_URL } from "../../global";
import { Tooltip } from "react-tooltip";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import InprogressLoader from "../Assets/Loaders/Inprogress";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Import the CSS for react-datepicker
// import { format } from "date-fns";

const EditModal = ({ showModal, closeModal, item }) => {
  const [formData, setFormData] = useState({
    rep_title: "",
    rep_provider: "",
    rep_org: "",
    rep_date: "",
    rep_notes: "",
    rep_page_range: "",
  });
  const [ogformData, setOGFormData] = useState({
    rep_title: "",
    rep_provider: "",
    rep_org: "",
    rep_date: "",
    rep_notes: "",
    rep_page_range: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handledateChange = (selecteddate) => {
    setFormData((prev) => ({
      ...prev,
      ["rep_date"]: selecteddate,
    }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedFields = {};

    // Compare formData with ogformData and store only the changed fields
    // Object.keys(formData).forEach((key) => {
    //     if (formData[key] !== ogformData[key]) {
    //         updatedFields[key] = formData[key]; // Only add the updated fields
    //     }
    // });
    Object.keys(formData).forEach((key) => {
      const current = formData[key];
      const original = ogformData[key];

      // Special handling for Date objects
      if (current instanceof Date && original instanceof Date) {
        if (current.getTime() !== original.getTime()) {
          updatedFields[key] = current;
        }
      }
      // If one is Date and other is null
      else if (
        (current instanceof Date && !original) ||
        (!current && original instanceof Date)
      ) {
        updatedFields[key] = current;
      }
      // Normal fields
      else if (current !== original) {
        updatedFields[key] = current;
      }
    });

    if (Object.keys(updatedFields).length === 0) {
      closeModal();
      return;
    }

    if (
      updatedFields.rep_date &&
      updatedFields.rep_date instanceof Date &&
      !isNaN(updatedFields.rep_date)
    ) {
      const dateObj = updatedFields.rep_date;

      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const day = dateObj.getDate().toString().padStart(2, "0");
      const year = dateObj.getFullYear();

      updatedFields.rep_date = `${month}/${day}/${year}`;
    }

    const reportData = {
      rep_id: item.rep_id,
      ...updatedFields,
    };

    try {
      // Trigger API call
      const caseID = localStorage.getItem("caseID");
      const response = await axios.post(`${API_BASE_URL}report_manage`, {
        case_id: caseID,
        report_data: [reportData],
        mode: "editReport",
      });

      if (response.data.status === 1) {
        closeModal();
        toast.success("Report updated successfully.");
      }
    } catch (error) {
      console.error("Network error:", error);
      alert("An error occurred while saving changes.");
    }
  };
  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    if (dateStr instanceof Date && !isNaN(dateStr)) {
      return dateStr;
    }
    if (typeof dateStr === "string" && dateStr.includes("/")) {
      const [month, day, year] = dateStr.split("/");
      const date = new Date(year, month - 1, day);
      return isNaN(date) ? null : date;
    }
    if (typeof dateStr === "string" && dateStr.includes("-")) {
      const parts = dateStr.split("-");
      if (parts.length === 3) {
        const [month, day, year] = parts;
        const date = new Date(year, month - 1, day);
        return isNaN(date) ? null : date;
      }
    }
    return null;
  };

  useEffect(() => {
    if (showModal && item) {
      setFormData({
        rep_title: item?.rep_title || "",
        rep_provider: item?.rep_provider || "",
        rep_org: item?.rep_org || "",
        rep_date: parseDate(item?.rep_date) || "",
        rep_notes: item?.rep_notes || "",
        rep_page_range: item?.rep_page_range || "",
      });
      setOGFormData({
        rep_title: item?.rep_title || "",
        rep_provider: item?.rep_provider || "",
        rep_org: item?.rep_org || "",
        rep_date: parseDate(item?.rep_date) || "",
        rep_notes: item?.rep_notes || "",
        rep_page_range: item?.rep_page_range || "",
      });
    }
  }, [showModal, item]);
  return (
    showModal && (
      <div className="modal-overlay">
        <div className="modal-container">
          {/* Modal Header */}
          <div className="d-flex justify-content-between align-items-center border-bottom py-2 px-3">
            <span className="attesta-blue">Edit Medical Index Report</span>
            <button onClick={closeModal} className="btn border-0 fs-5">
              <i className="fas fa-times"></i>
            </button>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            <div className="accordion-section">
              <div className="px-3 pb-3 mt-1">
                <div className="row g-2 mb-2 align-items-center">
                  <div className="col-12 d-flex">
                    <label
                      htmlFor="rep_title"
                      className="form-label me-2 mt-2"
                      style={{ flex: "0 0 100px" }}
                    >
                      Title
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="rep_title"
                      name="rep_title"
                      value={formData.rep_title}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="row g-2 align-items-center mb-2">
                  <div className="col-12 d-flex">
                    <label
                      htmlFor="rep_provider"
                      className="form-label me-2 mt-2"
                      style={{ flex: "0 0 100px" }}
                    >
                      Provider
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="rep_provider"
                      name="rep_provider"
                      value={formData.rep_provider}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="row g-2 align-items-center mb-2">
                  <div className="col-12 d-flex">
                    <label
                      htmlFor="rep_org"
                      className="form-label me-2 mt-2"
                      style={{ flex: "0 0 100px" }}
                    >
                      Organization
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="rep_org"
                      name="rep_org"
                      value={formData.rep_org}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="row g-2 align-items-center mb-2">
                  <div className="col-12 col-md-6 d-flex">
                    <label
                      htmlFor="rep_date"
                      className="form-label me-2 mt-1"
                      style={{ flex: "0 0 100px" }}
                    >
                      Date
                    </label>
                    {/* <input
                                            type="date"
                                            className="form-control"
                                            id="date"
                                            name="date"
                                            value={formData.date}
                                            onChange={handleChange}
                                        /> */}
                    <DatePicker
                      selected={
                        formData.rep_date instanceof Date &&
                        !isNaN(formData.rep_date)
                          ? formData.rep_date
                          : null
                      }
                      onChange={handledateChange}
                      name="rep_date"
                      dateFormat="MM-dd-yyyy"
                      className="form-control mb-1"
                      placeholderText="MM-dd-yyyy"
                    />
                  </div>
                  {/* <div className="col-12 col-md-6 d-flex">
                                        <label htmlFor="rep_page_range" className="form-label me-2 mt-1" style={{ flex: "0 0 100px" }}>
                                            Page Range
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="rep_page_range"
                                            name="rep_page_range"
                                            value={formData.rep_page_range}
                                            onChange={handleChange}
                                        />
                                    </div> */}
                </div>

                <div className="row g-2 align-items-center mb-2">
                  <div className="col-12 d-flex">
                    <label
                      htmlFor="rep_notes"
                      className="form-label me-2 mt-2"
                      style={{ flex: "0 0 100px" }}
                    >
                      Notes
                    </label>
                    <textarea
                      className="form-control"
                      id="rep_notes"
                      name="rep_notes"
                      value={formData.rep_notes}
                      onChange={handleChange}
                      rows="4"
                    />
                  </div>
                </div>

                <div className="row g-2 align-items-center mb-2">
                  {/* <div className="col-12 d-flex">
                                        <label htmlFor="pageRange" className="form-label me-2 mt-2" style={{ flex: "0 0 100px" }}>
                                            Page Range
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="pageRange"
                                            name="pageRange"
                                            value={formData.pageRange}
                                            onChange={handleChange}
                                        />
                                    </div> */}
                </div>

                <div className="d-flex justify-content-end mt-3">
                  <button type="submit" className="btn btn-primary">
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  );
};

const Medicalindex = ({ AISelectedApp }) => {
  // State for dropdown open/close
  const [isIncludeOpen, setIsIncludeOpen] = useState(false);
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [agentID, setagentID] = useState(null);
  const [isGroupByOpen, setIsGroupByOpen] = useState(false);
  const [isFilterByOpen, setIsFilterByOpen] = useState(false);
  const [reportGenerateProgress, setreportGenerateProgress] = useState(false);

  const [selectedSort, setSelectedSort] = useState("Title, A-Z");
  const [selectedGroupBy, setSelectedGroupBy] = useState("no");
  const [selectedFilterBy, setSelectedFilterBy] = useState("Date");
  const [filterValue, setFilterValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState([]);

  const [showEditModal, setShowEditModal] = useState(false);
  const [isLoading, setisloading] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});

  const [downloadReports, setDownloadReports] = useState([]); // Using static data
  const [showDownloadTable, setShowDownloadTable] = useState(false);

  const [downloadDisable, setdownloadDisable] = useState(false);
  const [downloadingIndex, setDownloadingIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);
  const [pageNumbers, setPageNumbers] = useState([]);

  const [isExcelDownloading, setisExcelDownloading] = useState(false);
  const [userId] = useState(() => Number(localStorage.getItem("userid")));

  // State for field dropdown's options
  const [includeOptions, setIncludeOptions] = useState([
    { label: "Title", value: "title", checked: true },
    { label: "Provider", value: "provider", checked: true },
    { label: "Organization", value: "organization", checked: true },
    { label: "Date", value: "date", checked: true },
    // { label: "Summary", value: "summary", checked: false },
    { label: "Notes", value: "notes", checked: false },
    // { label: "Page Range", value: "pageRange", checked: true },
    { label: "Original Page Range", value: "ogPageRange", checked: true },
    ...(Number(localStorage.getItem("user_id")) == 25
      ? [
          { label: "Serial Number", value: "serialNumber", checked: true },
          { label: "Excluded", value: "excluded", checked: true },
        ]
      : []),
  ]);
  // State for sort dropdown's options
  const [sortOptions, setSortOptions] = useState([
    { label: "Title, A-Z", value: "Title, A-Z" },
    { label: "Title, Z-A", value: "Title, Z-A" },
    { label: "Provider, A-Z", value: "Provider, A-Z" },
    { label: "Provider, Z-A", value: "Provider, Z-A" },
    { label: "Organization, A-Z", value: "Organization, A-Z" },
    { label: "Organization, Z-A", value: "Organization, Z-A" },
    { label: "Date, New to Old", value: "Date, New to Old" },
    { label: "Date, Old to New", value: "Date, Old to New" },
    { label: "S.No., A-Z", value: "SNumber, A-Z" },
    { label: "S.No., Z-A", value: "SNumber, Z-A" },
  ]);
  // State for group dropdown's options
  const [groupByOptions, setGroupByOptions] = useState([
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ]);

  // State for filter dropdown's options
  const [filterByOptions, setFilterByOptions] = useState([
    { label: "Title", value: "Title" },
    { label: "Provider", value: "Provider" },
    { label: "Organization", value: "Organization" },
    { label: "Date", value: "Date" },
  ]);

  // States for selections
  const [selectedInclude, setSelectedInclude] = useState({
    title: true,
    provider: true,
    organization: true,
    date: true,
    // summary: false,
    notes: false,
    pageRange: false,
    ogPageRange: true,
    serialNumber: Number(localStorage.getItem("userid")) == 25,
    excluded: Number(localStorage.getItem("userid")) == 25,
  });

  //handler for includeing header filter (Minimum 1 required)
  const handleincludeFilterChange = (filter) => {
    const updated = {
      ...selectedInclude,
      [filter]: !selectedInclude[filter],
    };

    // Ensure pageRange and ogPageRange cannot both be true
    if (filter === "pageRange" && updated.pageRange) {
      updated.ogPageRange = false;
    }

    if (filter === "ogPageRange" && updated.ogPageRange) {
      updated.pageRange = false;
    }

    const selectedCount = Object.values(updated).filter(Boolean).length;

    if (selectedCount === 0) return;

    setSelectedInclude(updated);
  };

  const handlesortByChange = (option) => {
    setSelectedSort(option);
    handleSort(option);
  };

  const handleGroupByChange = (option) => {
    setSelectedGroupBy(option);
  };

  const handleFilterByChange = (option) => {
    setFilterValue("");
    setFromDate("");
    setToDate("");
    setSelectedFilterBy(option);
    //  let sortedData = handleSort(AISelectedApp.agentData);
    let groupedData = groupByPageRange(AISelectedApp.agentData);
    setData(groupedData);
    generatePageNumbers();
  };

  const handleClearFilter = () => {
    setFilterValue("");
    setFromDate("");
    setToDate("");
    setSelectedFilterBy("");

    // let sortedData = handleSort(AISelectedApp.agentData);
    let groupedData = groupByPageRange(AISelectedApp.agentData);
    setData(groupedData);
    generatePageNumbers();
  };

  // Toggle dropdown visibility
  const toggleDropdown = (dropdown) => {
    if (dropdown === "include") setIsIncludeOpen(!isIncludeOpen);
    if (dropdown === "sort") setIsSortOpen(!isSortOpen);
    if (dropdown === "groupBy") setIsGroupByOpen(!isGroupByOpen);
    if (dropdown === "filterBy") setIsFilterByOpen(!isFilterByOpen);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const generatePageNumbers = () => {
    const range = [];
    const totalPages = Math.ceil(data.length / itemsPerPage);

    setPageNumbers([]);
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        range.push(i);
      }
    } else {
      const leftEllipsis = currentPage > 3;
      const rightEllipsis = currentPage < totalPages - 2;

      if (leftEllipsis) range.push(1);
      if (leftEllipsis && currentPage > 2) range.push("...");

      const start = Math.max(1, currentPage - 2);
      const end = Math.min(totalPages, currentPage + 2);

      for (let i = start; i <= end; i++) {
        range.push(i);
      }

      if (rightEllipsis && currentPage < totalPages - 2) range.push("...");
      if (rightEllipsis) range.push(totalPages);
    }

    setPageNumbers(range);
  };
  //Pagination handlers
  const paginate = (pageNumber) => {
    if (pageNumber === "...") return;
    setCurrentPage(pageNumber);
  };

  const fastBackward = () => {
    setCurrentPage(1);
  };

  const fastForward = () => {
    const totalPages = Math.ceil(data.length / itemsPerPage);
    setCurrentPage(totalPages);
  };

  // useEffect(() => {
  //     setData(AISelectedApp.agentData || []);
  // }, [AISelectedApp]);

  useEffect(() => {
    generatePageNumbers();
  }, [currentPage, data]);

  const getreportdata = async (AgentId) => {
    setShowEditModal(false);
    setSelectedItem({});
    setisloading(true);
    try {
      const caseID = localStorage.getItem("caseID");
      const response = await axios.post(`${API_BASE_URL}report_manage`, {
        case_id: caseID,
        mode: "sortReport",
        agent_id: AgentId,
        sort_choice: selectedSort,
      });

      if (response.data.status === 1) {
        const responsedata = response.data?.message || [];
        if (Array.isArray(responsedata)) {
          let groupedData = groupByPageRange(responsedata);
          setData(groupedData);
          generatePageNumbers();
          setisloading(false);
        } else {
          setData([]);
          setisloading(false);
        }
      }
    } catch (error) {
      setisloading(false);
      console.error("Error fetching tags:", error);
    }
  };

  useEffect(() => {
    let AgentId = AISelectedApp.agentSummaryId;
    setagentID(AgentId);
    getreportdata(AgentId);
  }, [AISelectedApp]);

  //handler for sort filter functionality
  const handleSort = async (option) => {
    // const sortedData = [...filteredData];

    // const parseDate = (dateStr) => {
    //     const [month, day, year] = dateStr.split('/');
    //     return new Date(`${year}-${month}-${day}`);
    // };
    // switch (selectedSort) {
    //     case "Title, A-Z":
    //         sortedData.sort((a, b) => {
    //             const titleA = a.rep_title || "";
    //             const titleB = b.rep_title || "";
    //             return titleA.localeCompare(titleB);
    //         });
    //         break;
    //     case "Title, Z-A":
    //         sortedData.sort((a, b) => {
    //             const titleA = a.rep_title || "";
    //             const titleB = b.rep_title || "";
    //             return titleB.localeCompare(titleA);
    //         });
    //         break;
    //     case "Provider, A-Z":
    //         sortedData.sort((a, b) => {
    //             const providerA = a.rep_provider || "";
    //             const providerB = b.rep_provider || "";
    //             return providerA.localeCompare(providerB);
    //         });
    //         break;
    //     case "Provider, Z-A":
    //         sortedData.sort((a, b) => {
    //             const providerA = a.rep_provider || "";
    //             const providerB = b.rep_provider || "";
    //             return providerB.localeCompare(providerA);
    //         });
    //         break;
    //     case "Organization, A-Z":
    //         sortedData.sort((a, b) => {
    //             const orgA = a.rep_org || "";
    //             const orgB = b.rep_org || "";
    //             return orgA.localeCompare(orgB);
    //         });
    //         break;
    //     case "Organization, Z-A":
    //         sortedData.sort((a, b) => {
    //             const orgA = a.rep_org || "";
    //             const orgB = b.rep_org || "";
    //             return orgB.localeCompare(orgA);
    //         });
    //         break;
    //     case "Date, New to Old":
    //         sortedData.sort((a, b) => parseDate(b.rep_date) - parseDate(a.rep_date));
    //         break;
    //     case "Date, Old to New":
    //         sortedData.sort((a, b) => parseDate(a.rep_date) - parseDate(b.rep_date));
    //         break;
    //     default:
    //         break;
    // }
    // return sortedData;
    setSelectedSort(option);

    try {
      const caseID = localStorage.getItem("caseID");
      const response = await axios.post(`${API_BASE_URL}report_manage`, {
        case_id: caseID,
        mode: "sortReport",
        agent_id: agentID,
        sort_choice: option,
      });

      if (response.data.status === 1) {
        const responsedata = response.data?.message || [];
        if (Array.isArray(responsedata)) {
          let groupedData = groupByPageRange(responsedata);
          setData(groupedData);
          generatePageNumbers();
        } else {
          setData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching saved search data:", error);
    }
  };

  //handler for value and date filter functionality
  const handleFilter = (data) => {
    let filteredData = [...data];
    console.log(selectedFilterBy, filterValue);
    if (selectedFilterBy !== "Date" && filterValue) {
      filteredData = filteredData.filter((item) =>
        item[
          `rep_${selectedFilterBy.toLowerCase() === "organization" ? "org" : selectedFilterBy.toLowerCase()}`
        ]
          ?.toLowerCase()
          .includes(filterValue.toLowerCase()),
      );
    }
    console.log(filteredData);

    if (selectedFilterBy === "Date") {
      let from = null;
      let to = null;

      // Only set from date if it's available
      if (fromDate) {
        from = new Date(fromDate);
        from.setHours(0, 0, 0, 0);
      }

      // Only set to date if it's available
      if (toDate) {
        to = new Date(toDate);
        to.setHours(23, 59, 59, 999);
      }

      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.rep_date);
        itemDate.setHours(0, 0, 0, 0);

        if (from && to) {
          return itemDate >= from && itemDate <= to;
        } else if (from) {
          return itemDate >= from;
        } else if (to) {
          return itemDate <= to;
        } else {
          return true;
        }
      });
    }

    return filteredData;
  };

  const handleSearchClick = () => {
    console.log(AISelectedApp.agentData);
    let filteredData = handleFilter(AISelectedApp.agentData || []);
    // let sortedData = handleSort(filteredData);
    let groupedData = groupByPageRange(filteredData);
    setData(groupedData);
    generatePageNumbers();
  };

  const groupByPageRange = (data) => {
    // if (selectedGroupBy === 'yes') {
    //     return data.reduce((acc, item) => {
    //         if (!acc[item.rep_page_range]) {
    //             acc[item.rep_page_range] = [];
    //         }
    //         acc[item.rep_page_range].push(item);
    //         return acc;
    //     }, {});
    // }
    return data;
  };

  const handleGenerateReport = async () => {
    const fields = [];
    if (selectedInclude.title) fields.push("Title");
    if (selectedInclude.provider) fields.push("Provider");
    if (selectedInclude.organization) fields.push("Organization");
    if (selectedInclude.date) fields.push("Date");
    if (selectedInclude.pageRange) fields.push("Page range");
    if (selectedInclude.ogPageRange) fields.push("Orig Pg Range");
    // if (selectedInclude.summary) fields.push("Summary");
    if (selectedInclude.notes) fields.push("Notes");
    if (selectedInclude.serialNumber) fields.push("Serial Number");

    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${month}/${day}/${year}`;
    };

    const formatfromDate = fromDate ? formatDate(fromDate) : "";
    const formattoDate = toDate ? formatDate(toDate) : "";

    const storedId = localStorage.getItem("caseID") || null;
    if (!storedId) {
      toast.error("No case ID found.");
      return;
    }

    const payload = {
      case_id: storedId,
      fields: fields,
      sorting: selectedSort,
      group_by: selectedGroupBy === "yes" ? 1 : 0,
      filter_by: selectedFilterBy || "Date",
      filter_text: filterValue,
      filter_fromDate: formatfromDate,
      filter_toDate: formattoDate,
      report_type: 1,
      mode: "reportRequest",
    };

    try {
      const response = await axios.post(`${API_BASE_URL}report`, payload);
      if (response.status === 200) {
        setreportGenerateProgress(true);
        checkProcessStatus();
      } else {
        // console.error("Error generating report:", result);
      }
    } catch (error) {
      console.error("API request failed:", error);
    }
  };

  const checkProcessStatus = async () => {
    const storedId = localStorage.getItem("caseID") || null;
    if (!storedId) {
      toast.error("No case ID found.");
      return;
    }
    try {
      const statusResponse = await axios.post(`${API_BASE_URL}report`, {
        case_id: storedId,
        mode: "checkReportStatus",
      });

      if (statusResponse.data.status === 1) {
        const statusData = statusResponse.data;
        if (statusData.message === "Process completed") {
          setreportGenerateProgress(false);
        } else {
          setreportGenerateProgress(true);
          setTimeout(() => checkProcessStatus(), 10000);
        }
      } else {
        console.error("Error fetching process status:", statusResponse);
      }
    } catch (error) {
      console.error("Error checking process status:", error);
    }
  };
  const getgenerateddownloadList = async () => {
    const storedId = localStorage.getItem("caseID") || null;
    if (!storedId) {
      toast.error("No case ID found.");
      return;
    }
    try {
      const reportResponse = await axios.post(`${API_BASE_URL}report`, {
        case_id: storedId,
        mode: "reportList",
        report_type: 1,
      });

      if (reportResponse.status === 200) {
        const generatedreportdata = reportResponse.data?.message;
        if (generatedreportdata === "No report available") {
          console.log("No report available.");
          setDownloadReports([]);
          return [];
        } else if (
          generatedreportdata &&
          Array.isArray(generatedreportdata) &&
          generatedreportdata.length > 0
        ) {
          setDownloadReports(generatedreportdata);
          return generatedreportdata;
        } else {
          console.log("No reports found.");
          setDownloadReports([]);
          return [];
        }
      } else {
        console.error("Error fetching generated report:", reportResponse);
      }
    } catch (error) {
      console.error("Error checking generated report:", error);
    }
  };

  const handleDownloadReports = () => {
    setShowDownloadTable(true);
  };

  useEffect(() => {
    if (!showDownloadTable) return;

    let timeoutId;

    const pollReports = async () => {
      const reports = await getgenerateddownloadList();
      console.log(reports);
      const hasPending = reports?.some(
        (r) => r.repStatus === 0 || r.repStatus === 2,
      );

      if (hasPending) {
        timeoutId = setTimeout(pollReports, 5000); // schedule next poll
      }
    };

    pollReports(); // Start immediately

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [showDownloadTable]);

  function randomPrefix() {
    return Math.floor(100 + Math.random() * 900); // 3-digit random prefix
  }
  const handlefileDownloadReports12 = async (path, index) => {
    setdownloadDisable(true);
    setDownloadingIndex(index);
    const pdfUrl = path;
    const case_id = localStorage.getItem("caseID") || null;
    try {
      const response = await axios.post(
        `${API_BASE_URL}download_pdf`,
        { pdf_url: pdfUrl },
        {
          responseType: "blob",
          headers: { "Content-Type": "application/json" },
        },
      );
      const pdfBlob = response.data;
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      const zip = new JSZip();
      const pdffileName = `${randomPrefix()}${case_id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
      zip.file(`${pdffileName}.pdf`, pdfBlob);
      const zipBlob = await zip.generateAsync({ type: "blob" });
      const fileName = `${randomPrefix()}${case_id}${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
      saveAs(zipBlob, `${fileName}.zip`);
      toast.success("Zip file downloaded successfully.");
      setdownloadDisable(false);
      setDownloadingIndex(null);
    } catch (err) {
      console.error("Error downloading and zipping PDF:", err);
      setdownloadDisable(false);
      setDownloadingIndex(null);
    }
  };

  // const handlefileDownloadReports = async (path, index) => {
  //     setdownloadDisable(true);
  //     setDownloadingIndex(index);

  //     try {
  //         const response = await axios.post(
  //             `${API_BASE_URL}zip_file`,
  //             { pdf_url: path },
  //             { responseType: "blob" }  // zip as blob
  //         );

  //         const disposition = response.headers["content-disposition"];
  //         let fileName = "download.zip";

  //         if (disposition) {
  //             const fileNameMatch = disposition.match(/filename\*=UTF-8''(.+)|filename="?([^"]+)"?/);
  //             if (fileNameMatch) {
  //                 fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
  //             }
  //         }

  //         // Create blob URL and trigger download
  //         const url = window.URL.createObjectURL(new Blob([response.data]));
  //         const link = document.createElement("a");
  //         link.href = url;
  //         link.setAttribute("download", fileName);
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);

  //         toast.success("Zip file downloaded successfully.");
  //     } catch (err) {
  //         console.error("Error downloading zip:", err);
  //     } finally {
  //         setdownloadDisable(false);
  //         setDownloadingIndex(null);
  //     }
  // };
  const handlefileDownloadReports = async (path, index) => {
    setdownloadDisable(true);
    setDownloadingIndex(index);

    try {
      const response = await axios.post(
        `${API_BASE_URL}zip_file`,
        { pdf_url: path },
        { responseType: "blob" }, // download as blob
      );

      // ✅ Axios lowercases headers
      const disposition = response.headers["content-disposition"];

      console.log(response.headers);
      console.log(disposition);
      let fileName = "download.zip";

      if (disposition) {
        // Handles both filename="xxx.zip" and filename*=UTF-8''xxx.zip
        const fileNameMatch = disposition.match(
          /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/,
        );
        if (fileNameMatch) {
          fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
        }
      }

      // ✅ Create blob URL and trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success(`Report downloaded successfully.`);
    } catch (err) {
      console.error("Error downloading Report:", err);
      toast.error("Failed to download Report file.");
    } finally {
      setdownloadDisable(false);
      setDownloadingIndex(null);
    }
  };

  const handlebackclickReports = () => {
    setShowDownloadTable(false);
  };

  // Handling the change for From Date
  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  // Handle change for "To Date"
  const handleToDateChange = (date) => {
    setToDate(date);
  };

  useEffect(() => {
    checkProcessStatus();
  }, []);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setShowEditModal(true);
  };

  const handleHide = async (item) => {
    Swal.fire({
      title: item.rep_active === 1 ? "Hide this item?" : "Unhide this item?",
      text: "Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: item.rep_active === 1 ? "Hide" : "Unhide",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const caseID = localStorage.getItem("caseID");
          const payload = {
            case_id: caseID,
            report_data: [
              {
                rep_active: item.rep_active === 1 ? 0 : 1,
                rep_id: item.rep_id,
              },
            ],
            mode: "editReport",
          };
          const response = await axios.post(
            `${API_BASE_URL}report_manage`,
            payload,
          );

          if (response.data.status === 1) {
            getreportdata(agentID);
            toast.success("Report has been updated successfully.");
          } else {
            toast.error("Failed to updated the report");
          }
        } catch (error) {
          console.error("Failed to updated the report:", error);
          toast.error("An error occurred while updating report.");
        }
      }
    });
  };

  const closeModal = async () => {
    setShowEditModal(false);
    setSelectedItem({});
    try {
      const caseID = localStorage.getItem("caseID");
      const response = await axios.post(`${API_BASE_URL}report_manage`, {
        case_id: caseID,
        mode: "sortReport",
        agent_id: agentID,
        sort_choice: selectedSort,
      });

      if (response.data.status === 1) {
        const responsedata = response.data?.message || [];
        if (Array.isArray(responsedata)) {
          let groupedData = groupByPageRange(responsedata);
          setData(groupedData);
          generatePageNumbers();
        } else {
          setData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };
  const saveChanges = (updatedData) => {
    console.log("Updated Data:", updatedData);
  };

  async function downloadExcelIndex() {
    setisExcelDownloading(true);

    try {
      const caseID = localStorage.getItem("caseID");

      const response = await axios.post(
        `${API_BASE_URL}generateexcelreport`,
        {
          case_id: caseID,
          mode: "med_index",
        },
        {
          responseType: "blob",
        },
      );

      const fileBlob = response.data;

      let fileNameInsideZip = "report.xlsx";
      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match && match[1]) {
          fileNameInsideZip = match[1];
        }
      }

      const mimeType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      const safeBlob =
        fileBlob instanceof Blob
          ? fileBlob
          : new Blob([fileBlob], { type: mimeType });

      const zip = new JSZip();
      zip.file(fileNameInsideZip, safeBlob);

      const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, "");
      const randomKey = Math.random().toString(36).slice(2, 8);
      const zipFileName = `download_${timestamp}_${randomKey}.zip`;

      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, zipFileName);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    } finally {
      setisExcelDownloading(false);
    }
  }

  return (
    <div className="container mt-2">
      <EditModal
        showModal={showEditModal}
        closeModal={closeModal}
        item={selectedItem}
      />
      <Tooltip
        id="ai-summary-tooltip"
        className="tooltip-custom align-items-center"
      />
      <h3
        className=" d-flex justify-content-between align-items-center w-100"
        data-tooltip-id="ai-summary-tooltip"
        data-tooltip-content={"AttestaAI Report"}
      >
        <div className="analysis-row">
          <div className="d-flex align-items-center">
            <div className="custom-icon-wrapper">
              <span
                className="custom-icon attesta-blue"
                dangerouslySetInnerHTML={{
                  __html:
                    AISelectedApp?.summaryPmtIcon ||
                    '<i class="fa-solid fa-brain custom-icon"></i>',
                }}
              ></span>
            </div>
            <span className="ms-2 attesta-blue">
              {AISelectedApp?.summaryPmtLabel || "AttestaAI Summary"}
            </span>
          </div>
        </div>
      </h3>

      {showDownloadTable ? (
        <div
          style={{
            marginLeft: "-2%",
            // marginRight: "-6%"
          }}
        >
          <div className="d-flex text-start align-items-center mb-2">
            {/* Back Button */}
            <span
              onClick={handlebackclickReports}
              className="d-flex align-items-center"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 20 20"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                className="shrink-0 me-1"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5 10C5 9.85913 5.05943 9.72479 5.16366 9.63003L10.6637 4.63003C10.868 4.44428 11.1842 4.45933 11.37 4.66366C11.5557 4.86799 11.5407 5.18422 11.3363 5.36997L6.7933 9.5L17.5 9.5C17.7761 9.5 18 9.72386 18 10C18 10.2761 17.7761 10.5 17.5 10.5L6.7933 10.5L11.3363 14.63C11.5407 14.8158 11.5557 15.132 11.37 15.3363C11.1842 15.5407 10.868 15.5557 10.6637 15.37L5.16366 10.37C5.05943 10.2752 5 10.1409 5 10Z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.5 2C2.77614 2 3 2.22386 3 2.5L3 17.5C3 17.7761 2.77614 18 2.5 18C2.22385 18 2 17.7761 2 17.5L2 2.5C2 2.22386 2.22386 2 2.5 2Z"
                />
              </svg>
            </span>
            {/* Heading */}
            <h5 className="mt-1 mb-1">Downloaded Report Data</h5>
          </div>

          <div
            style={{
              minHeight: "250px",
              maxHeight: "calc(-250px + 100vh)",
              overflowY: "auto",
            }}
          >
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100%" }}
              >
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <>
                <Tooltip
                  id="download-tooltip"
                  className="tooltip-custom align-items-center"
                />

                <Table hover>
                  <thead className="custom-header-border">
                    <tr>
                      <th>S.No</th>
                      <th>Fields</th>
                      <th>Sorting</th>
                      <th>Group by</th>
                      <th>Filter by</th>
                      <th>Filter text</th>
                      <th>Status</th>
                      <th>Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    {downloadReports?.length > 0 ? (
                      downloadReports?.map((item, index) => (
                        <tr key={index} className="custom-row-border">
                          <td>{index + 1}</td>
                          <td>{item.repFields}</td>
                          <td>{item.repSorting}</td>
                          <td>{item.repGroupBy === "0" ? "No" : "Yes"}</td>
                          <td>{item.repFilterBy}</td>
                          <td>{item.repFilterText}</td>
                          <td>
                            <span className="badge attesta-blue">
                              {item.repStatus === 0 ? (
                                <InprogressLoader text="Inprogress" />
                              ) : item.repStatus === 2 ? (
                                <InprogressLoader text="In progress" />
                              ) : item.repStatus === 3 ? (
                                "Not Found In Report"
                              ) : (
                                "Completed"
                              )}
                            </span>
                          </td>
                          <td>
                            {/* <Button variant="light" size="sm" className="download-btn" disabled={item.repStatus !== 1 || downloadDisable} onClick={() => handlefileDownloadReports(item.repOutputFile)}>
                                                        <i className="fas fa-cloud-download-alt me-1"></i> Download
                                                    </Button> */}
                            {downloadingIndex === index ? (
                              // Show animation when downloading
                              <>
                                <InprogressLoader text="Downloading" />
                              </>
                            ) : (
                              <Button
                                variant="light"
                                size="sm"
                                className={`download-btn ${item.repStatus === 1 && !downloadDisable ? "attesta-blue" : ""}`}
                                disabled={
                                  item.repStatus !== 1 || downloadDisable
                                }
                                onClick={() =>
                                  handlefileDownloadReports(
                                    item.repOutputFile,
                                    index,
                                  )
                                }
                                data-tooltip-id="download-tooltip"
                                data-tooltip-content={
                                  item.repStatus === 0
                                    ? "Report is still in progress"
                                    : item.repStatus === 2
                                      ? "Report generation failed"
                                      : item.repStatus === 3
                                        ? "Report not found"
                                        : ""
                                }
                              >
                                <i className="fas fa-cloud-download-alt me-1"></i>{" "}
                                Download
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} className="text-center text-muted py-3">
                          No report available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </>
            )}
          </div>
        </div>
      ) : (
        <>
          <div className="container mt-2 p-3 border rounded shadow-sm mb-2">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 ">
              {/* INCLUDE Dropdown */}
              <div className="d-flex align-items-center flex-wrap gap-2 ">
                <div>
                  <Dropdown
                    show={isIncludeOpen}
                    onToggle={() => toggleDropdown("include")}
                  >
                    <Dropdown.Toggle
                      id="include-dropdown"
                      onClick={() => toggleDropdown("include")}
                      variant="light"
                      size="sm"
                    >
                      <i className="fas fa-list me-2"></i> INCLUDE
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {includeOptions.map((option) => (
                        <Dropdown.Item
                          as="button"
                          key={option.value}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <FormCheck
                            type="checkbox"
                            label={option.label}
                            checked={selectedInclude[option.value]}
                            onChange={() =>
                              handleincludeFilterChange(option.value)
                            }
                          />
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                {/* SORT Dropdown */}
                <div>
                  <Dropdown
                    show={isSortOpen}
                    onToggle={() => toggleDropdown("sort")}
                  >
                    <Dropdown.Toggle
                      id="sort-dropdown"
                      onClick={() => toggleDropdown("sort")}
                      variant="light"
                      size="sm"
                    >
                      <i className="fas fa-sort me-2"></i> SORT
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {sortOptions.map((option) => (
                        <Dropdown.Item
                          as="button"
                          key={option.value}
                          onClick={() => handleSort(option.value)}
                        >
                          <FormCheck
                            type="radio"
                            label={option.label}
                            checked={selectedSort === option.value}
                            // onChange={() => handlesortByChange(option.value)}
                            readOnly
                          />
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                {/* GROUP BY PAGE RANGE Dropdown */}
                <div>
                  <Dropdown
                    show={isGroupByOpen}
                    onToggle={() => toggleDropdown("groupBy")}
                  >
                    <Dropdown.Toggle
                      id="groupby-dropdown"
                      onClick={() => toggleDropdown("groupBy")}
                      variant="light"
                      size="sm"
                    >
                      <i className="fas fa-filter me-2"></i> GROUP BY PAGE RANGE
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {groupByOptions.map((option) => (
                        <Dropdown.Item
                          as="button"
                          key={option.value}
                          onClick={() => handleGroupByChange(option.value)}
                        >
                          <FormCheck
                            type="radio"
                            label={option.label}
                            checked={selectedGroupBy === option.value}
                            // onChange={() => handleGroupByChange(option.value)}
                            readOnly
                          />
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                {/* FILTER BY Dropdown */}
                <div>
                  <Dropdown
                    show={isFilterByOpen}
                    onToggle={() => toggleDropdown("filterBy")}
                  >
                    <Dropdown.Toggle
                      id="filterby-dropdown"
                      onClick={() => toggleDropdown("filterBy")}
                      variant="light"
                      size="sm"
                    >
                      <i className="fas fa-cogs me-2"></i> FILTER BY
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      style={{
                        zIndex: 1050,
                        position: "absolute",
                        padding: "10px",
                        width: "250px",
                      }}
                    >
                      {filterByOptions.map((option) => (
                        <div
                          key={option.value}
                          className="mb-2"
                          onClick={(e) => handleFilterByChange(option.value)}
                        >
                          <FormCheck
                            type="radio"
                            name="filterBy"
                            label={option.label}
                            value={option.value}
                            checked={selectedFilterBy === option.value}
                            // onChange={(e) => handleFilterByChange(option.value)}
                            readOnly
                          />
                        </div>
                      ))}
                      {/* Input fields */}
                      {selectedFilterBy === "Date" ? (
                        <>
                          <DatePicker
                            selected={fromDate}
                            onChange={handleFromDateChange}
                            dateFormat="MM-dd-yyyy"
                            className="form-control mb-1"
                            placeholderText="MM-dd-yyyy"
                          />
                          <DatePicker
                            selected={toDate}
                            onChange={handleToDateChange}
                            dateFormat="MM-dd-yyyy"
                            className="form-control mb-1"
                            placeholderText="MM-dd-yyyy"
                          />
                        </>
                      ) : (
                        <Form.Control
                          type="text"
                          placeholder={`Enter ${selectedFilterBy}`}
                          value={filterValue}
                          onChange={(e) => setFilterValue(e.target.value)}
                          className="mb-2"
                        />
                      )}

                      {/* Clear button and Search button */}
                      <div className="d-flex justify-content-between align-items-center">
                        <Button
                          variant="primary"
                          onClick={handleSearchClick}
                          disabled={!selectedFilterBy}
                        >
                          Search
                        </Button>
                        <Button variant="light" onClick={handleClearFilter}>
                          <i className="fas fa-times"></i>
                        </Button>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <div>
                <div className="d-flex justify-content-start gap-2">
                  {/* Tooltip always mounted, no condition */}
                  <Tooltip
                    id="generate-report-tooltip"
                    className="tooltip-custom"
                    place="top"
                  />
                  <span
                    data-tooltip-id={
                      reportGenerateProgress
                        ? "generate-report-tooltip"
                        : undefined
                    }
                    data-tooltip-content={
                      reportGenerateProgress
                        ? "Report generation is in progress"
                        : undefined
                    }
                    style={{ display: "inline-block" }}
                  >
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={handleGenerateReport}
                      disabled={reportGenerateProgress}
                      className={
                        reportGenerateProgress ? "btn-disabled-custom" : ""
                      }
                    >
                      Generate Report
                    </Button>
                  </span>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleDownloadReports}
                  >
                    Download Reports
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={downloadExcelIndex}
                  >
                    {isExcelDownloading ? "Downloading..." : "Download Excel"}
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <h4 className="mb-1">Report results</h4>
          <div
            style={{
              minHeight: "200px",
              maxHeight: "calc(-350px + 100vh)",
              overflowY: "auto",
            }}
          >
            <Table hover>
              <thead className="custom-header-border">
                <tr>
                  {selectedInclude.title && <th>Title</th>}
                  {selectedInclude.provider && <th>Provider</th>}
                  {selectedInclude.organization && <th>Organization</th>}
                  {selectedInclude.date && <th>Date</th>}
                  {selectedInclude.notes && <th>Notes</th>}
                  {/* {selectedInclude.summary && <th>Summary</th>} */}
                  {selectedInclude.pageRange && <th>Page Range</th>}
                  {selectedInclude.ogPageRange && <th>Original Page Range</th>}
                  {userId == 25 && selectedInclude.serialNumber && <th>Serial Number</th>}
                  {userId == 25 && selectedInclude.excluded && <th>Excluded</th>}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item, index) => (
                    <tr key={index} className="custom-row-border">
                      {selectedInclude.title && <td>{item.rep_title}</td>}
                      {selectedInclude.provider && <td>{item.rep_provider}</td>}
                      {selectedInclude.organization && <td>{item.rep_org}</td>}
                      {selectedInclude.date && <td>{item.rep_date}</td>}
                      {selectedInclude.notes && <td>{item.rep_notes}</td>}
                      {/* {selectedInclude.summary && <td>{item.rep_summary}</td>} */}
                      {selectedInclude.pageRange && (
                        <td>{item.rep_page_range}</td>
                      )}
                      {selectedInclude.ogPageRange && (
                        <td>{item.rep_og_page_range}</td>
                      )}
                      {userId == 25 && selectedInclude?.serialNumber && (
                        <td>{item.rep_serial_number || 0}</td>
                      )}
                      {userId == 25 && selectedInclude?.excluded && (
                        <td>
                          {item.rep_is_excluded === 1
                            ? "True"
                            : item.rep_is_excluded === 0
                              ? ""
                              : null}
                        </td>
                      )}

                      <td>
                        <div className="d-flex gap-2 justify-content-center">
                          <Tooltip
                            id={`edit-tooltip-${index}`}
                            className="tooltip-custom"
                            place="top"
                          />
                          <Tooltip
                            id={`hide-tooltip-${index}`}
                            className="tooltip-custom"
                            place="top"
                          />

                          <div
                            data-tooltip-id={`edit-tooltip-${index}`}
                            data-tooltip-content="Edit"
                          >
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => handleEdit(item)}
                            >
                              <i className="fas fa-edit"></i>
                            </Button>
                          </div>

                          {/* <div data-tooltip-id={`hide-tooltip-${index}`} data-tooltip-content="Hide">
                                                    <Button variant="outline-primary" size="sm" onClick={() => handleHide(item)}>
                                                        <i className="fas fa-eye-slash"></i>
                                                    </Button>
                                                </div> */}
                          <div
                            data-tooltip-id={`hide-tooltip-${index}`}
                            data-tooltip-content={
                              item.rep_active === 1 ? "Hide" : "Unhide"
                            }
                          >
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => handleHide(item)}
                            >
                              <i
                                className={`fas ${item.rep_active === 1 ? "fa-eye" : "fa-eye-slash"}`}
                              ></i>
                            </Button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={
                        Object.values(selectedInclude).filter(Boolean).length +
                          1 || 1
                      }
                      className="text-center text-muted py-3"
                    >
                      No report available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <Pagination className="custom-pagination justify-content-end mt-1">
            <Pagination.First
              onClick={fastBackward}
              disabled={currentPage === 1}
            />
            <Pagination.Prev
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {pageNumbers.map((number, idx) => (
              <Pagination.Item
                key={idx}
                active={number === currentPage}
                onClick={() => paginate(number)}
              >
                {number}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === pageNumbers[pageNumbers.length - 1]}
            />
            <Pagination.Last
              onClick={fastForward}
              disabled={currentPage === pageNumbers[pageNumbers.length - 1]}
            />
          </Pagination>
        </>
      )}
    </div>
  );
};

export default Medicalindex;